import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './Home.js';
import AboutPage from './AboutPage.js';
import ProductTemplate from './ProductTemplate.js';
import ContactPage from './ContactPage.js';
import AccreditedFinderPage from './AccreditedFinderPage.js';
import BecomeApplicatorPage from './BecomeApplicatorPage.js';

const GoogleFontImport = () => (
  <React.Fragment>
    <link
      href="https://fonts.googleapis.com/css2?family=Bai+Jamjuree:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap"
      rel="stylesheet"
    />
    <style jsx global>{`
      body {
        font-family: 'Bai Jamjuree', sans-serif;
      }
    `}</style>
  </React.Fragment>
);

const App = () => {
  // Apply dark mode class based on system preference or saved choice
  React.useEffect(() => {
    try {
      const saved = window.localStorage.getItem('theme');
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      const enableDark = saved ? saved === 'dark' : prefersDark;
      document.documentElement.classList.toggle('dark', !!enableDark);
      if (window.matchMedia) {
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e) => {
          const savedNow = window.localStorage.getItem('theme');
          if (!savedNow) document.documentElement.classList.toggle('dark', e.matches);
        };
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
      }
    } catch {}
    return undefined;
  }, []);
  const ScrollToTop = () => {
    const { pathname } = useLocation();
    React.useEffect(() => {
      if (pathname === '/produtos') {
        const scrollToShowcase = () => {
          const target = document.getElementById('product-showcase');
          if (target) {
            target.scrollIntoView({ behavior: 'auto', block: 'start' });
            return true;
          }
          return false;
        };

        if (!scrollToShowcase()) {
          const timeoutId = window.setTimeout(scrollToShowcase, 50);
          return () => window.clearTimeout(timeoutId);
        }
        return undefined;
      }

      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return undefined;
    }, [pathname]);
    return null;
  };

  const SetPageTitle = () => {
    const { pathname } = useLocation();
    React.useEffect(() => {
      const brand = 'Gtechniq Brasil';

      // Helper to pretty-name routes
      const pageNameFor = (path) => {
        if (path === '/' || path === '') return '';
        if (path === '/sobre') return 'Sobre';
        if (path === '/contato') return 'Contato';
        if (path === '/encontre-um-profissional') return 'Aplicadores & Revendas';
        if (path === '/seja-um-aplicador-oficial') return 'Seja um Aplicador Oficial';
        if (path === '/produtos') {
          // Only show "Produtos - …" after user actually clicked Produtos
          const visited = typeof window !== 'undefined' && window.sessionStorage.getItem('visitedProdutos') === '1';
          return visited ? 'Produtos' : '';
        }
        if (path.startsWith('/produtos/')) return 'Produto';
        // Fallback for dynamic product short URLs like /c1-crystal-lacquer
        if (/^\/[a-z0-9\-]+$/i.test(path)) return 'Produto';
        return '';
      };

      const page = pageNameFor(pathname);
      document.title = page ? `${page} - ${brand}` : brand;
    }, [pathname]);
    return null;
  };

  return (
    <React.Fragment>
      <GoogleFontImport />
      <Router>
        <ScrollToTop />
        <SetPageTitle />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produtos" element={<Home />} />
          <Route path="/produtos/:id" element={<ProductTemplate />} />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/encontre-um-profissional" element={<AccreditedFinderPage />} />
          <Route path="/contato" element={<ContactPage />} />
          <Route path="/seja-um-aplicador-oficial" element={<BecomeApplicatorPage />} />
          <Route path="/:id" element={<ProductTemplate />} />
        </Routes>
      </Router>
    </React.Fragment>
  );
};

export default App;
